import { render, staticRenderFns } from "./StudentsWithPausedCourses.vue?vue&type=template&id=59a5cb0d"
import script from "./StudentsWithPausedCourses.vue?vue&type=script&lang=ts"
export * from "./StudentsWithPausedCourses.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports